<template>
    <div>
        <v-app-bar
            :color="primaryColor(generalExApplicationEx)"
            dense
            dark
            :absolute="absolute != false"
        >
            <v-tooltip v-if="!external" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-if="true"
                        v-bind="attrs"
                        v-on="on"
                        @click="goApplications"
                    >
                        <v-icon>mdi-apps</v-icon>
                    </v-btn>
                </template>
                <span>
                    {{ translatedText("applications") }}
                </span>
            </v-tooltip>

            <v-toolbar-title v-if="!external" class="text-button">
                {{ applicationTitle(generalExApplicationEx, customLanguage) }}
            </v-toolbar-title>
            <v-toolbar-title v-else class="text-button">
                {{ title }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-title v-if="!external" class="text-center">
                <div class="text-caption framework-name">
                    {{ frameWorkName(generalExApplicationEx) }}
                </div>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip v-if="!external" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="goHome" v-bind="attrs" v-on="on">
                        <v-icon>mdi-home</v-icon>
                    </v-btn>
                </template>
                <span> {{ translatedText("home") }} </span>
            </v-tooltip>

            <v-tooltip bottom v-if="okAlerts()">
                <template v-slot:activator="{ on, attrs }">
                    <v-badge
                        :color="alertsCount > 0 ? 'red' : 'transparent'"
                        :content="alertsCount"
                        offset-x="20"
                        offset-y="21"
                    >
                        <v-btn
                            icon
                            @click="$emit('toggle-alert-bar-drawer')"
                            v-on="on"
                            v-bind="attrs"
                        >
                            <v-icon> mdi-bell </v-icon>
                        </v-btn>
                    </v-badge>
                </template>
                <span>{{
                    translatedText("alerts") +
                    (alertsCount > 0 ? " (" + alertsCount + ")" : "")
                }}</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        @click="switchLanguage"
                        v-bind="attrs"
                        v-on="on"
                    >
                        {{ invertedLanguage(generalExApplicationEx) }}
                    </v-btn>
                </template>
                <span>
                    {{ translatedText("switchLanguage") }}
                </span>
            </v-tooltip>

            <!-- Menu -->
            <div class="text-center" v-if="okMenu()">
                <v-menu
                    v-model="profile"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-x
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            small
                            fab
                            dark
                            v-bind="attrs"
                            v-on="on"
                            :color="primaryColor(generalExApplicationEx)"
                            elevation="0"
                        >
                            <v-icon>mdi-account-circle</v-icon>
                        </v-btn>
                    </template>

                    <v-card>
                        <v-list>
                            <v-list-item>
                                <v-list-item-avatar class="avatar">
                                    {{ session.details.initials }}
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>{{
                                        session.details.fullName
                                    }}</v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        session.details.userName
                                    }}</v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn icon>
                                        <v-icon>mdi-heart</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>

                        <v-divider></v-divider>

                        <v-list>
                            <v-list-item>
                                <v-list-item-action>
                                    <v-btn
                                        class="ma-2"
                                        fab
                                        small
                                        @click="logoff"
                                    >
                                        <v-icon>mdi-exit-to-app</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                                <v-list-item-title>{{
                                    translatedText("logoff")
                                }}</v-list-item-title>
                            </v-list-item>
                        </v-list>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </div>

            <v-tooltip bottom v-if="okMenu()">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        @click="$emit('toggle-menu-bar-drawer')"
                        v-on="on"
                        v-bind="attrs"
                    >
                        <v-icon> mdi-menu </v-icon>
                    </v-btn>
                </template>
                <span>{{ translatedText("menu") }}</span>
            </v-tooltip>
        </v-app-bar>
    </div>
</template>

<script>
export default {
    name: "AppBarFrame",
    props: [
        "session",
        "environment",
        "generalExApplicationEx",
        "absolute",
        "applicationName",
        "customLanguage",
        "external",
        "title",
        "alertsCount",
    ],
    data() {
        return {
            profile: false,
        };
    },
    methods: {
        logoff() {
            this.$emit("logoff", this.applicationName);
            this.profile = false;
        },
        goHome() {
            if (this.session?.loggedIn) {
                this.$emit("go-home");
            } else {
                this.goToRoot();
            }
        },

        switchLanguage() {
            this.$emit("switch-language");
        },

        goApplications() {
            this.$emit("go-applications");
        },

        updateFavico() {
            const favicon = document.getElementById("main-page-favicon");
            if (favicon) {
                favicon.href = this.fullIcon(this.generalExApplicationEx);
            }
        },

        updateTitle() {
            const title = document.getElementById("main-page-title");
            if (title) {
                const alerts =
                    this.alertsCount > 0 ? "(" + this.alertsCount + ") " : "";
                const app = this.applicationTitle(
                    this.generalExApplicationEx,
                    this.customLanguage
                );
                const all =
                    alerts +
                    (app
                        ? app
                        : this.frameWorkName(this.generalExApplicationEx));
                if (!this.external && !this.title) {
                    title.textContent = all;
                } else {
                    title.textContent = this.title;
                }
            }
        },

        okAlerts() {
            return (
                this.session?.loggedIn &&
                !this.external &&
                this.alertsEnabled(this.generalExApplicationEx)
            );
        },

        okMenu() {
            return this.session?.loggedIn && !this.external;
        },

        okApps() {
            return this.session?.loggedIn;
        },
    },

    mounted() {
        this.updateFavico();
        this.updateTitle();
    },

    updated() {
        this.updateFavico();
        this.updateTitle();
    },
};
</script>

<style>
.avatar {
    background-color: gray;
    color: white;
}
.logo {
    opacity: 0.5;
}
.framework-name {
    color: rgb(200, 200, 200);
}
</style>